import { getIdentifier } from '~/mst/utils';
import type { IOrganization } from '~/mst/models/organization';
import i18n from '~/utils/i18n';
import { getFiltersItemsList } from '~/mst/models/abstract/filterable/actions';
import type { IOrganizationsModel } from './model';

export default (self: IOrganizationsModel) => ({
  // counted over the organizations the list shows (members only), "with partners" first
  get getOrgPartnershipsFiltersItemsList() {
    const members = self.filteredModels.filter((organization) => organization.is_member);
    return getFiltersItemsList(members, 'org-partnerships').reverse();
  },
  get valueLabelPairsIsMember() {
    return self.valueLabelPairs.filter(({ model }) => model.is_member);
  },
  get valueLabelPairsIsMemberWithAll() {
    const options = self.valueLabelPairsIsMember;
    if (options.length > 1) {
      return [{ value: 'all', label: i18n.t('base.labels.all') }, ...options];
    }
    return options;
  },
  get valueLabelPairsManagerAccess() {
    return self.valueLabelPairs.filter(({ model }) => model.hasManagerAccess);
  },
  get valueLabelPairsCanManageReports() {
    return self.valueLabelPairs.filter(({ model }) => model.canManageReports);
  },
  get valueLabelPairsCanReadReports() {
    return self.valueLabelPairs.filter(({ model }) => model.canReadReports);
  },
  get valueLabelPairsCanManageDashboards() {
    return self.valueLabelPairs.filter(({ model }) => model.canManageDashboards);
  },
  get valueLabelPairsCanManageSharedDashboards() {
    return self.valueLabelPairs.filter(({ model }) => model.canManageSharedDashboards);
  },
  getOrganizationIdByExternalId(id?: string) {
    const organization = self.toArray.find(({ external_id }) => external_id.toLowerCase() === id?.toLowerCase());
    if (organization) {
      return getIdentifier(organization);
    }
    return null;
  },
  get valueLabelPairsExternalId() {
    return self.valueLabelPairs.map(({ label, model }) => ({
      label,
      value: model.external_id
    }));
  },
  get filteredList() {
    return self.filteredModels
      .filter((organizatiion) => organizatiion.is_member)
      .map((organization: IOrganization) => ({
        id: organization.id,
        isSyncing: organization.isSyncing,
        is_locked: organization.is_locked,
        isDisabled: organization.is_locked,
        name: organization.name,
        logo: organization.logo,
        location: organization.shippingLocation,
        created_at: organization.created_at,
        stats: organization.stats.groupByType,
        external_id: organization.external_id,
        contactFullName: organization.contactFullName,
        contact_email: organization.contact_email
      }));
  }
});
